import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PlayCircleFilledSvg from "@ant-design/icons-svg/es/asn/PlayCircleFilled";
import AntdIcon from '../components/AntdIcon';
var PlayCircleFilled = function PlayCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: PlayCircleFilledSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(PlayCircleFilled);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'PlayCircleFilled';
}
export default RefIcon;